<template>
  <div class="about-wrap">
    <img class="img-cover" :src="`${imgUrlPrefix}${ isMobile ? 'm-main.jpg' : 'main.jpg' }`" alt="" />
    <div class="about-content">
      <img class="about-logo" :src="`${imgUrlPrefix}logo-light.png`" />
      <p v-html="content1"></p>
      <p v-html="content2"></p>
    </div>
  </div>
</template>

<script>
import { checkIsMobile } from '../utils/tools.js'
export default {
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  computed: {
    content1() {
      return this.isMobile ? 
        'METTA——由212越野车联合六感工业、越野e族<br>正式推出旗下首个越野生态系列<br>作为212从“生而越野”走向“不止越野”的战略一步<br>METTA跨界联结时尚、科技、艺术等领域<br>在经典风格中注入时尚与精致的先锋表达<br>诠释“前卫的经典主义”<br>兼具荒野驰骋与城市穿行的双重能力' 
        :
        'METTA——由212越野车联合六感工业、越野e族正式推出旗下首个越野生态系列<br>作为212从“生而越野”走向“不止越野”的战略一步<br>METTA跨界联结时尚、科技、艺术等领域，在经典风格中注入时尚与精致的先锋表达，诠<br>释“前卫的经典主义”，兼具荒野驰骋与城市穿行的双重能力'
    },
    content2() {
      return this.isMobile ? 
        '性能上，赛道验证的底盘调校、动力匹配与车身刚性全面反哺<br>METTA，并配备丰富的官方升级套件和性能升级方案<br>满足从入门到深度玩家的不同需求<br>生态层面，METTA携手赛车运动、文旅、长途穿越等领域伙<br>伴，构建从荒野到赛道、从装备到保障、从线上社区到线下营<br>地的完整生态闭环，为用户提供覆盖越野生活方式的综合生态<br>服务、多元玩法及无忧保障，让越野更有趣、更长久'
        :
        '性能上，赛道验证的底盘调校、动力匹配与车身刚性全面反哺METTA<br>并配备丰富的官方升级套件和性能升级方案，满足从入门到深度玩家的不同需求<br>生态层面，METTA携手赛车运动、文旅、长途穿越等领域伙伴，构建从荒野到赛道、从装备<br>到保障、从线上社区到线下营地的完整生态闭环，为用户提供覆盖越野生活方式的综合生态<br>服务、多元玩法及无忧保障，让越野更有趣、更长久'
    }
  },
  data() {
    const imgUrlPrefix = '/assets/images/about/'
    return {
      imgUrlPrefix,
      isMobile: false,
    }
  },
  methods: {
    checkDevice() {
      this.isMobile = checkIsMobile()
    },
  },
}
</script>

<style lang="less" scoped>
.about-wrap {
  width: 100%;
  height: 100vh;
  position: relative;
  .about-content {
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    width: 100%;
    .about-logo {
      width: 15.53vw;
      height: auto;
      margin: 8.33vw auto 0;
    }
    p {
      margin-top: 2.44vw;
      font-size: clamp(18px, 1.5vw, 28px);
      color: #fff;
      font-weight: @fw2;
      line-height: 1.6;
    }
  }
}
@media (max-width: @mobile-width) {
  .about-wrap {
    .about-content {
      .about-logo {
        width: 58.67vw;
        margin: 34.67vw auto 0;
      }
      p {
        margin-top: 8.8vw;
        font-size: 3.2vw;
      }
    }
  }
}
</style>